import { z } from "zod"

import { SemesterEnum } from "@/common/enum/semesterEnum"

// POST /api/sync/requests
export const POSTRequest = z.object({
    year: z.number().int(),
    semester: z.enum(SemesterEnum),
})

export const POSTResponse = z.object({
    requestId: z.string(),
    createdAt: z.date(),
})

export type POSTSyncRequestBody = z.infer<typeof POSTRequest>
export type POSTSyncRequestResponse = z.infer<typeof POSTResponse>
